
import AddCustomField from 'layouts/customfield/AddCustomField.js';
import EditCustomField from 'layouts/customfield/EditCustomField.js';
import ManageCustomField from 'layouts/customfield/ManageCustomField.js';
import ProtectedRoute from "routes/protectedRoutes.js";
const VendorRoutes = [

  {
    route: "productCustomfield/add",
    key: "EditVenproductCustomfield-add",
    component: <ProtectedRoute check="logout"><AddCustomField props={{'type':1}}/></ProtectedRoute>
  },

  {
    route: "productCustomfield/edit/:id/:type",
    key: "EditVenproductCustomfield-edit",
    component: <ProtectedRoute check="logout"><EditCustomField props={{'type':1}}/></ProtectedRoute>
  },
  {
    route: "serviceCustomfield/add",
    key: "serviceCustomfield-add",
    component: <ProtectedRoute check="logout"><AddCustomField props={{'type':2}}/></ProtectedRoute>
  },

  {
    route: "serviceCustomfield/edit/:id/:type",
    key: "serviceCustomfield-edit",
    component: <ProtectedRoute check="logout"><EditCustomField props={{'type':2}}/></ProtectedRoute>
  },
  {
    route: "serviceCustomfield/manage",
    key: "serviceCustomfield",
    component: <ProtectedRoute check="logout"><ManageCustomField props={{'type':2}}/></ProtectedRoute>
  },

  {
    route: "vendorCustomfield/add",
    key: "vendorCustomfield-add",
    component: <ProtectedRoute check="logout"><AddCustomField props={{'type':3}}/></ProtectedRoute>
  },

  {
    route: "vendorCustomfield/edit/:id/:type",
    key: "vendorCustomfield-edit",
    component: <ProtectedRoute check="logout"><EditCustomField props={{'type':3}}/></ProtectedRoute>
  },
  {
    route: "vendorCustomfield/manage",
    key: "serviceCustomfield",
    component: <ProtectedRoute check="logout"><ManageCustomField props={{'type':3}}/></ProtectedRoute>
  },

  {
    route: "productCustomfield/manage",
    key: "manageproductCustomfield",
    component: <ProtectedRoute check="logout"><ManageCustomField props={{'type':1}}/></ProtectedRoute>
  }

  ];

export default VendorRoutes;
 